import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import ExportBox from "../components/ExportBox/ExportBox"
import CustomTable from "../components/CustomTable/CustomTable"
import { Container } from "react-bootstrap"
import { useEffect, useState } from "react"
import axios from "axios"
import { useSelector } from "react-redux"

function SchoolStructureGrades() {
    const userinfo = useSelector((state) => state);
    const [items, setItems] = useState([])
    const { currentLocal } = useSelector((state) => state.currentLocal);
    const [gradeItems, setGradeItems] = useState([])
    const getAllApis = async () => {

        await axios
            .get(`https://nanosoft.space/taarteb/public/api/grades`, {
                headers: {
                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                }
            })
            .then(async (res) => {
              console.log(res.data.data.data);
              
                            setItems(res.data.data.data)


            })
            .catch((error) => {




            });



            await axios
            .get(`https://nanosoft.space/taarteb/public/api/grade-categories`, {
              headers: {
                Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
              }
            })
            .then(async (res) => {
              console.log(res.data.data.data);
              
              const options = res.data.data.data.map(item => ({
                value: item.id, 
                label: item.name 
              }));
              console.log(options);
              
              setGradeItems(options)
    
    
            })
            .catch((error) => {
    
    
            });
    }

    useEffect(() => {
 
        getAllApis()

    }, [])
    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.namePlaceholder,
        currentLocal.home.stageName
        ,

    ]
    return (
        <div className="px-0 my-3 w-100 dashboard_content">
            <Container>
                <div className="d-flex flex-column w-100">
                    <AuthNavbar />
                    <div className="mt-5 mx-3">
                        <HomeTitle title={currentLocal.home.grades} />
                        <ExportBox
                            title={""}
                            paragrapg={' '}
                            addingBtn={currentLocal.home.AddGrades}

                            exportState={false}


                        />

                        <CustomTable
                            data={items}
                            headerIterm={headerIterm}
                            gradeItems={gradeItems}
                            onDataChanged={getAllApis} 
                                                onSubmitAttendance={()=>{}}


                        />


                    </div>

                </div>
            </Container>
        </div>
    )
}

export default SchoolStructureGrades

